/**
 * P3-20: PolicyButton —— 政策按钮（迁移自
 * classes.ui.PolicyBtnController + BuildingResearchBtn，
 * js/science.js:2426-2600 / core.js:2402-2404）。
 *
 * 行为对齐：
 * - 名称：controller.getName 产出 HTML（blocked 时追加 BLOCKED）
 * - 描述：aria-description 取 model.description
 * - 可见：meta.unlocked；受 policyToggleResearched/policyToggleBlocked 影响
 * - 禁用：已研究/已阻塞/资源不足
 * - tooltip：ButtonModernHelper.getTooltipHTML 直取
 * - 点击：controller.buyItem(modelRef.current, event)（内部处理确认弹窗）
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { usePolicyButtonModel } from "./useScienceModel";

interface PolicyButtonProps {
  policyName: string;
}

export function PolicyButton({ policyName }: PolicyButtonProps) {
  const { snap, modelRef, controller, getTooltip } =
    usePolicyButtonModel(policyName);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
